import { render } from "./Cookies.vue?vue&type=template&id=bab7ae0a&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=bab7ae0a&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=bab7ae0a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src534590742/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab7ae0a"]])

export default __exports__